module.exports = __webpack_public_path__ + "static/media/IMA_pres.ede3f12c.jpg";